import ArticleLayout from '@/components/feature/ArticleLayout';
import articleContents from '@/mocks/article-content';

export default function ArticleVerificare() {
  return <ArticleLayout article={articleContents['come-verificare-prodotti']} />;
}